// External packages
import * as React from 'react';

// Components
import { Button } from 'components/Button';
import { Icon } from 'components/Icons';
import { Card } from 'components/Card';

// Modules
import { AddImageModal } from 'modules/images/AddImageModal';
import { ImageGallery } from 'modules/images/ImageGallery';

// Hooks
import { useUploadMedia, useAddImageTranslations } from 'api/media';

export default function ImagesPage() {
  const [modalOpen, setModalOpen] = React.useState(false);

  const { mutate: uploadMedia, isPending: isUploading } = useUploadMedia();
  const { mutate: addTranslations, isPending: isAddingTranslations } =
    useAddImageTranslations();

  const handleImageSubmit = (data: {
    image: File;
    translations: { languageCode: string; description: string }[];
  }) => {
    uploadMedia(
      {
        file: data.image,
        fileType: 'images',
      },
      {
        onSuccess: (uploadResult) => {
          if (uploadResult?.data?.id && data.translations.length > 0) {
            addTranslations(
              {
                imageId: uploadResult.data.id,
                translations: { translations: data.translations },
              },
              {
                onSuccess: () => setModalOpen(false),
              }
            );
          }
        },
      }
    );
  };

  return (
    <Card className="flex flex-col h-full min-h-[calc(100vh-9rem)] md:min-h-[calc(100vh-8rem)]">
      <div className="flex items-center justify-between gap-x-8 gap-y-4">
        <h1 className="text-2xl text-gray-600">Slike</h1>
        <AddImageModal
          isOpen={modalOpen}
          onOpenChange={setModalOpen}
          onSubmit={handleImageSubmit}
          modalTrigger={
            <Button icon={<Icon name="plus" />}>Dodaj sliku</Button>
          }
          isPending={isUploading || isAddingTranslations}
        />
      </div>
      <hr className="my-6 h-px text-gray-200" />
      <ImageGallery />
    </Card>
  );
}
